import React, { useState } from "react";
import "../styles/Contact.css";

const Contact = () => {
  // form state (includes honeypot: company)
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
    company: "", // honeypot
  });

  const [status, setStatus] = useState({ state: "idle", msg: "" });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setStatus({ state: "sending", msg: "" });

      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (!res.ok) throw new Error();

      setStatus({
        state: "success",
        msg: "Sent! I’ll get back to you soon 💌",
      });
      setForm({ name: "", email: "", message: "", company: "" });

      // optional: auto-hide success after a bit
      setTimeout(() => setStatus({ state: "idle", msg: "" }), 3500);
    } catch {
      setStatus({ state: "error", msg: "Oops—try again in a moment." });
    }
  };

  return (
    <div className="contact-container">
      <h1 className="contact-title">Let’s Connect ₊˚⊹☆</h1>

      <form className="contact-form" onSubmit={handleSubmit}>
        {/* Honeypot field (hidden from users) */}
        <input
          type="text"
          name="company"
          value={form.company}
          onChange={handleChange}
          className="hp-field"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
        />

        <div className="form-group">
          <label htmlFor="name-input">
            Name <span aria-label="required">*</span>
          </label>
          <input
            id="name-input"
            type="text"
            name="name"
            placeholder="Your name"
            value={form.name}
            onChange={handleChange}
            required
            aria-required="true"
            aria-describedby="name-help"
          />
          <small id="name-help" className="form-help">
            Please enter your full name
          </small>
        </div>

        <div className="form-group">
          <label htmlFor="email-input">
            Email <span aria-label="required">*</span>
          </label>
          <input
            id="email-input"
            type="email"
            name="email"
            placeholder="your.email@example.com"
            value={form.email}
            onChange={handleChange}
            required
            aria-required="true"
            aria-describedby="email-help"
          />
          <small id="email-help" className="form-help">
            Enter a valid email address so I can reply
          </small>
        </div>

        <div className="form-group">
          <label htmlFor="message-input">
            Message <span aria-label="required">*</span>
          </label>
          <textarea
            id="message-input"
            name="message"
            placeholder="Tell me something  (-_-?)"
            rows="4"
            value={form.message}
            onChange={handleChange}
            required
            aria-required="true"
            aria-describedby="message-help"
          />
          <small id="message-help" className="form-help">
            Please share your message or inquiry
          </small>
        </div>

        <button
          type="submit"
          disabled={status.state === "sending"}
          className={`send-btn ${status.state}`}
        >
          {status.state === "sending" ? (
            <span className="btn-content">
              <span className="sparkle" aria-hidden="true">
                ✦
              </span>
              Sending…
              <span className="mini-spinner" aria-hidden="true" />
            </span>
          ) : status.state === "success" ? (
            <span className="btn-content">Sent! 💌</span>
          ) : (
            <span className="btn-content">Send!</span>
          )}
        </button>

        {status.state !== "idle" && status.msg && (
          <p className={`form-status ${status.state}`} aria-live="polite">
            {status.msg}
          </p>
        )}
      </form>

      <div className="contact-links">
        <p>
          Find me on{" "}
          <a
            href="https://www.linkedin.com/in/lilu-montoya-5605b5260/"
            target="_blank"
            rel="noreferrer"
          >
            LinkedIn
          </a>{" "}
          or{" "}
          <a href="https://github.com/mlilu" target="_blank" rel="noreferrer">
            GitHub
          </a>
          !
        </p>
      </div>
    </div>
  );
};

export default Contact;
